import { forwardRef } from 'react'

import { BaseInput, BaseInputProps } from '../BaseInput'

export type TextInputProps = BaseInputProps

export const TextInput = forwardRef<HTMLInputElement, BaseInputProps>(
  ({ ...props }, ref) => {
    return <BaseInput type="text" ref={ref} {...props} />
  },
)
